import React, { Fragment } from 'react'
import style from './post-intro.mod.scss'
import { graphql } from 'gatsby'
import { formatDateTime } from '@helpers/miscHelpers'
import { Button } from '@components'

const PostIntro = ({
  title,
  author,
  meta,
  eventTime,
  eventLocation,
  categories,
  isEvent = false
}) => {
  return (
    <div className={style['post-intro']}>
      <h1>{title}</h1>
      <div className={style['post-intro__meta']}>
        <div className={style['post-intro__inner']}>
          {isEvent ? (
            <Fragment>
              {eventTime && (
                <span className={style['post-intro__event-time']}>
                  {formatDateTime(eventTime, `D MMM YYYY, h:mma`) || `Time TBA`}
                </span>
              )}
              {eventLocation && (
                <span className={style['post-intro__location']}>
                  {eventLocation || `Location TBA`}
                </span>
              )}
            </Fragment>
          ) : (
            <Fragment>
              {meta?.publishedAt && (
                <span className={style['post-intro__published']}>
                  {formatDateTime(meta.publishedAt)}
                </span>
              )}
              {author && (
                <span className={style['post-intro__author']}>{author}</span>
              )}
            </Fragment>
          )}
        </div>
        {categories.length > 0 && (
          <div className={style['post-intro__categories']}>
            {categories.map((category, i) => (
              <Fragment key={category.id}>
                <Button
                  onClick={category.onClick}
                  unstyled
                  children={category.title}
                />
                {i !== categories.length - 1 && ', '}
              </Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export const query = graphql`
  fragment PostIntro on DatoCmsPost {
    title
    author
    path
    categories {
      title
      slug
      id
    }
    eventLocation
    eventTime
    meta {
      publishedAt
    }
  }
`

export default PostIntro
